import React, { useEffect, useRef, useState } from "react";

import nav from "./_nav";
import get from "lodash/get";
import map from "lodash/map";
import gql from "graphql-tag";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import history from "@meds/shared/history";
import createApolloClient from "@meds/shared/apollo-client";

import { ApolloProvider as ApolloHooksProvider } from "react-apollo-hooks";
import { Router, Switch } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { PrivateRoute } from "./containers";

import { AppProvider } from "./AppContext";
import { useQuery } from "react-apollo-hooks";
import { Loading } from "./components/Loading";
import { useAuth0 } from "@meds/contexts/react-auth0-spa";

import "./App.scss";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { useSession } from "./hooks/useSession";
// import ModalProfileLayout from "../src/containers/ModalProfileLayout/ModalProfileLayout";
//
const GET_PROFILE = gql`
  query GetProfile($where: ProfileWhereUniqueInput!) {
    profile: getProfile(where: $where) {
      profile {
        id
        name
        isCenterAdmin
        isActivityValidation

        views {
          name
        }
      }

      profilePatient {
        id
        name
      }

      user {
        profileIdPatient
        profileId
        id
        email
        code
        name
        identification
        centers {
          id
          name
          allowsDirectRegistration
          code
        }
        arses {
          id
        }
        companies {
          id
          company {
            id
            name
          }
        }
      }
      options {
        id
        value
      }
      isStaff
      staffCenters {
        id
        name
      }
    }
  }
`;

const GET_MY_DISPENSARY_BRANCHES = gql`
  query GetMyDispensaryBranches {
    getMyDispensaryBranches {
      dispensaryBranchId
      dispensaryId
      companyName
      branchOfficeName
    }
  }
`;

const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

//Layout de los Resultados
const ResultsLayout = React.lazy(() =>
  import("./containers/ResultsLayout/ResultsLayout")
);
//Layout para las ARS
const ARSLayout = React.lazy(() => import("./containers/ARSLayout/ARSLayout"));
//Layout para la Pantalla de Pacientes en Espera ss
const AwaitBody = React.lazy(() =>
  import("./containers/PatientAwaitLayout/AwaitBody")
);

const ModalProfileLayout = React.lazy(() =>
  import("./containers/ModalProfileLayout/ModalProfileLayout")
);

const DispensaryBranchModal = React.lazy(() =>
  import("./containers/DispensaryBranchModal/DispensaryBranchModal")
);

//Layout pantalla de check-in asd
const CheckIn = React.lazy(() => import("./containers/CheckIn"));

const InitialNoticeLayout = React.lazy(() =>
  import("./containers/InitialNoticeLayout")
);

function AppRoute({ loading, user }) {
  const [hasReadNotice, setHasReadNotice] = useState(
    () => sessionStorage.getItem("hasReadInitialNotice") === "true"
  );
  let metadata = {};
  const option = {};
  const permissionViews = {};
  const navigation = { items: [] };
  let profileId = null;
  let profileIdPatient = null;

  const { loading: ploading, data: { profile } = {} } = useQuery(GET_PROFILE, {
    skip: loading || !user,
    fetchPolicy: "network-only",
    variables: { where: { usersub: get(user, "sub") } }
  });

  const { data: dispensaryBranchesData } = useQuery(
    GET_MY_DISPENSARY_BRANCHES,
    {
      skip: loading || !user,
      fetchPolicy: "network-only"
    }
  );

  const dispensaryBranches =
    dispensaryBranchesData?.getMyDispensaryBranches || [];

  if (!loading && !ploading) {
    forEach(get(profile, "profile.views", []), pv => {
      permissionViews[pv.name] = true;
    });

    forEach(get(profile, "options"), item => {
      option[item.id] = item.value;
    });

    profileId = get(profile, "profile.id", null);
    profileIdPatient = get(profile, "user.profileIdPatient", null);

    navigation.items = filter(
      map(nav.items, item => {
        const children = filter(
          item.children,
          ic => permissionViews[ic.permission]
        );
        return { ...item, children };
      }),
      item => item.children.length > 0
    );

    if (!!user) {
      metadata = user["https://app2.meds.com.do/user_metadata"];
    }
  }

  const { saveSessionTracking } = useSession();
  const hasTrackedEntryRef = useRef(false);

  const profileIdToCheck = profileId || profileIdPatient;

  const centers =
    profile?.isStaff || false
      ? profile?.staffCenters || []
      : profile?.user?.centers || [];

  const requiresCenterSelection = centers.length > 1;
  const requiresDispensaryBranchSelection = dispensaryBranches.length > 1;
  const selectedCenter = JSON.parse(sessionStorage.getItem("centerSelected"));
  const selectedDispensaryBranch = JSON.parse(
    sessionStorage.getItem("dispensaryBranchSelected")
  );

  useEffect(() => {
    if (!loading && !ploading && user && !hasTrackedEntryRef.current) {
      if (requiresCenterSelection && !selectedCenter) {
        return;
      }

      hasTrackedEntryRef.current = true;

      (async () => {
        const profilesExcluded = [16, 997, 998, 999];
        if (!profilesExcluded.includes(profileIdToCheck)) {
          if (requiresCenterSelection) {
            await saveSessionTracking({
              accessType: "entry",
              centerSelectedId: selectedCenter?.id
            });
          } else {
            if (!selectedCenter && centers?.[0]?.id) {
              sessionStorage.setItem(
                "centerSelected",
                JSON.stringify(centers?.[0])
              );
            }
            await saveSessionTracking({
              accessType: "entry",
              centerSelectedId: centers?.[0]?.id
            });
          }
        }
      })();
    }
  }, [
    loading,
    ploading,
    user,
    saveSessionTracking,
    profileIdToCheck,
    requiresCenterSelection,
    selectedCenter
  ]);

  window.print = console.log;

  const LayoutReturn = key => {
    const sessionProfile = JSON.parse(
      sessionStorage.getItem("profileSelected")
    );

    const sessionCenter = JSON.parse(sessionStorage.getItem("centerSelected"));

    console.log({
      sessionProfile,
      sessionCenter,
      test: !!profileId && !!profileIdPatient && !!sessionProfile
    });

    const requiresProfileSelection = !!profileId && !!profileIdPatient;
    const requiresCenterSelection = (centers?.length || 0) > 1;

    const hasRequiredSelections =
      (!requiresProfileSelection || !!sessionProfile) &&
      (!requiresCenterSelection || !!sessionCenter);

    const isStaff = get(profile, "isStaff", false);
    const isActivityValidation = get(
      profile,
      "profile.isActivityValidation",
      false
    );

    if (requiresDispensaryBranchSelection && !selectedDispensaryBranch) {
      return DispensaryBranchModal;
    }

    if (
      isActivityValidation &&
      (requiresProfileSelection || requiresCenterSelection) &&
      !hasRequiredSelections
    ) {
      return ModalProfileLayout;
    }

    if (isStaff && !hasReadNotice) {
      return props => (
        <InitialNoticeLayout
          {...props}
          onComplete={() => setHasReadNotice(true)}
          centerId={requiresCenterSelection ? selectedCenter?.id : null}
        />
      );
    }

    const currentProfileId = sessionProfile?.id || key;

    switch (currentProfileId) {
      case 16:
        return ARSLayout;
      case 997:
        return CheckIn;
      case 998:
        return AwaitBody;
      case 999:
        return ResultsLayout;
      default:
        return DefaultLayout;
    }
  };

  console.log(profile);

  const profiles = [];
  const profileMain = get(profile, "profile", null);
  if (profileMain) profiles.push(profileMain);
  const profilePatient = get(profile, "profilePatient", null);
  if (profilePatient) profiles.push(profilePatient);

  return (
    <div>
      {(loading || ploading) && <Loading />}
      {!loading && !ploading && (
        <AppProvider
          value={{
            option,
            profileId,
            metadata,
            navigation,
            permissionViews,
            user: {
              ...get(profile, "user", null),
              isStaff: get(profile, "isStaff", false),
              staffCenters: get(profile, "staffCenters", []),
              dispensaryBranches,
              profile: get(profile, "profile", null),
              profilePatient: get(profile, "profilePatient", null),
              profiles
            },
            center: get(metadata, "centers[0]", null)
          }}
        >
          <Router history={history}>
            <React.Suspense fallback={<Loading />}>
              <Switch>
                <PrivateRoute
                  path="/"
                  name="Home"
                  component={LayoutReturn(
                    profileId ? profileId : profileIdPatient
                  )}
                />
              </Switch>
            </React.Suspense>
          </Router>
        </AppProvider>
      )}
    </div>
  );
}
//
export default function App() {
  const { loading, user, logout, getTokenSilently } = useAuth0();
  const apolloClient = createApolloClient({
    logout,
    getTokenSilently,
    uri: process.env.REACT_APP_APOLLO_CLIENT_URI
  });

  console.log({ user });

  return (
    <ApolloProvider client={apolloClient}>
      <ApolloHooksProvider client={apolloClient}>
        <Provider store={store}>
          <AppRoute loading={loading} user={user} />
        </Provider>
      </ApolloHooksProvider>
    </ApolloProvider>
  );
}
